import React from 'react';

import PropTypes from 'prop-types';
import AdminSettings from './AdminSetting';

const SystemSettingsCommon = props => {
  const { settings, save } = props;
  const values = {
    redis_exp: settings.redis_exp,
    mqtt_server: settings.mqtt_server,
    mqtt_port: settings.mqtt_port,
    srtm_server: settings.srtm_server,
  };

  return (
    <AdminSettings
      key="COMMON"
      save={save}
      valuesInit={values}
      settingTitle="COMMON"
    />
  );
};

SystemSettingsCommon.propTypes = {
  settings: PropTypes.object.isRequired,
  save: PropTypes.func.isRequired,
};
export default SystemSettingsCommon;
